import type { JSX } from 'react'
import type { IDropdownItemTypeButtonProps } from '../DropdownItemTypeButton'

import {
  DropdownItemBackgrounds,
  DropdownItemFontColors,
  DropdownItemFonts,
  DropdownItemPaddings,
} from '../../DropdownItem.h'
import { DropdownItemTypeButton } from '../DropdownItemTypeButton'

export interface IDropdownItemLanguageProps extends IDropdownItemTypeButtonProps {}

export const DropdownItemLanguage = ({
  id = 0,
  title = '',
  font = DropdownItemFonts.Button2,
  colorDefault = DropdownItemFontColors.TEXT_ICON_PRIMARY,
  backgroundSelectedDefault = DropdownItemBackgrounds.SURFACE_OPACITY_LIGHT_10,
  paddings = DropdownItemPaddings.SIZE_20,
  ...rest
}: IDropdownItemLanguageProps): JSX.Element => (
  <DropdownItemTypeButton
    id={id}
    title={title}
    font={font}
    colorDefault={colorDefault}
    backgroundSelectedDefault={backgroundSelectedDefault}
    paddings={paddings}
    {...rest}
  />
)
